module.exports = __webpack_public_path__ + "static/logo-sample-1b67f56541c2dcd70c17357b7d691311.png";